export default class UserSearch {
    constructor (dto) {
        this.id = 0
        this.name = ''
        this.conditionStr = ''
        this.isParameterizable = false
        this.addToTaskManager = false
        this.contentTypeIDs = []
        this.searchAllVersions = false

        if (dto) {
            this.id = dto.Id
            this.name = dto.FilterName
            this.conditionStr = dto.FilterStr
            this.isParameterizable = dto.IsParameterizable
            this.addToTaskManager = dto.IsBasket
            this.contentTypeIDs = dto.ContentTypeIDs == '' ? [] : dto.ContentTypeIDs.split(',')
            this.searchAllVersions = dto.SearchAllVersions
        }
    }

    toDto () {
        return {
            Id: this.id,
            FilterName: this.name,
            FilterStr: this.conditionStr,
            IsParameterizable: this.isParameterizable,
            IsBasket: this.addToTaskManager,
            SearchAllVersions: this.searchAllVersions,
            ContentTypeIDs: this.contentTypeIDs.length == 0 ? '' : this.contentTypeIDs.join(','),
        }
    }
}
